export const questRankings = /* GraphQL */ `
  query RanksForQuestByScore(
    $questId: ID
    $score: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestRankFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ranksForQuestByScore(
      questId: $questId
      score: $score
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        score
        player {
          id
          name
        }
      }
      nextToken
    }
  }
`;

export const getPlayerProfile = /* GraphQL */ `
  query GetPlayerProfile(
    $id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelActivityPeriodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getPlayer(id: $id) {
      id
      name
      createdAt
      updatedAt
      starTotal
      effortTotal
      rideDurTotal
      wattHrsTotal
      coinTotal
    }
    activityPeriodByPlayer(
      owner: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          items {
            id
            title
            duration
            wattHours
            createdAt
          }
          nextToken
        }
      }
      nextToken
    }
    ranksForPlayerByCreated(
      owner: $id
      sortDirection: $sortDirection
      limit: $limit
    ) {
      items {
        createdAt
        score
        starRating
        owner
        questId
        rideId
        effortId
        updatedAt
        quest {
          id
          title
          worldId
          type
        }
      }
      nextToken
    }
  }
`;

export const getRide = /* GraphQL */ `
  query GetRide($id: ID!) {
    getRide(id: $id) {
      id
      createdAt
      title
      duration
      kilometers
      wattHours
      coinGain
      starGain
      completed
      owner
      player {
        name
      }
      worldId
      updatedAt
      activityPeriod {
        id
        startDate
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          questId
          quest {
            title
            type
          }
          rideId
          updatedAt
        }
        nextToken
      }
      questRanks {
        items {
          createdAt
          score
          starRating
          questId
          rideId
          effortId
          updatedAt
        }
        nextToken
      }
    }
  }
`;
